{
  "headings": {
    "feedback": "Give feedback",
    "givenFeedback": "Given feedback",
    "feedbackPreview": "Feedback preview",
    "feedbackDetail": "Feedback details",
    "preview": "Preview",
    "success": "Feedback"
  },
  "texts": {
    "instructions": "Participate in development, share your ideas!\n\nWe want to improve our operations and your insights are important to us. Share your experiences, ideas, or development suggestions using this form.",
    "success": "Your feedback has been sent. Thank you for your feedback!",
    "expectsResponseInstructions": "Do you want a response to your feedback? If you wish to receive a response, please mention it in your message. This way, we can ensure that we get back to you as smoothly as possible.",
    "contactDetailsUpdateInstructions": "If necessary, you can update your contact details here. You can also edit them through the My Information page."
  },
  "placeholders": {
    "title": "Title",
    "description": "Please specify what your feedback is about"
  },
  "alt": {
    "successIllustration": "Thank you illustration"
  },
  "labels": {
    "title": "Title",
    "description": "Description",
    "files": "Attachments",
    "email": "Email",
    "phoneNumber": "Phone",
    "expectsResponse": "I want to be contacted"
  },
  "actions": {
    "back": "Back",
    "resetForm": "Clear form",
    "sendForm": "Send feedback",
    "preview": "Preview",
    "edit": "Edit",
    "submit": "Submit"
  },
  "errors": {
    "submitError": "Error sending the feedback. If the problem persists, please contact customer service.",
    "serviceUnavailable": "Feedback creation is not available at the moment. Please try again later.",
    "noFeedbackFound": "No feedback found.",
    "missingUserPhoneNumber": {
      "title": "Unfortunately, feedback creation failed",
      "message": "To continue creating feedback, please add your phone number to your profile."
    }
  }
}
